"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormContext = exports.responseToFormErrors = void 0;
const react_1 = require("react");
function getFormErrorMessage(json) {
    if (Array.isArray(json)) {
        return json.map((row) => (typeof row === 'object' ? Object.keys(row)
            .map((key) => row[key])
            .join('.') : row)).join('.');
    }
    return json;
}
function responseToFormErrors(error, formContext) {
    return __awaiter(this, void 0, void 0, function* () {
        const { formData } = formContext;
        // error is not response error, runtime error.
        if (!('response' in error)) {
            return [{
                    attribute: 'main',
                    message: error.message,
                }];
        }
        const resp = error.response;
        let json;
        try {
            json = yield resp.clone().json();
        }
        catch (_a) {
            // sometimes like a response of 413, there is no json returned.
            return [{
                    attribute: 'main',
                    message: error.message,
                }];
        }
        if (!json.errors && json.message) {
            return [{
                    attribute: 'main',
                    message: json.message,
                }];
        }
        // Request data error.
        if (json.errors) {
            // Validation of form input.
            let fieldErrors = Object.keys(json.errors)
                .map((attribute) => ({
                attribute,
                message: getFormErrorMessage(json.errors[attribute]),
            }));
            // These are errors that we cant map to a field of the form.
            const orphanedErrors = fieldErrors.filter((newFormError) => !formData.hasOwnProperty(newFormError.attribute));
            if (orphanedErrors.length > 0) {
                // filter out orphans
                fieldErrors = fieldErrors
                    .filter((fieldError) => !orphanedErrors.map((o) => o.attribute).includes(fieldError.attribute));
                // make a main
                fieldErrors.push({
                    attribute: 'main',
                    message: (orphanedErrors.map((oe) => oe.message)).join('\n'),
                });
            }
            return fieldErrors;
        }
        return [{
                attribute: 'main',
                message: 'Unknown error',
            }];
    });
}
exports.responseToFormErrors = responseToFormErrors;
exports.FormContext = react_1.createContext({
    inForm: false,
    formData: {},
    errors: [],
});
exports.FormContext.displayName = 'FormContext';
